<template>
    <div :class="{
        has_sublist: card.hasSubList || card.courseType == 23,
        offset_y: !(card.priceFen === 0 && !card.hasSubList)
        }"
        class="course-card"
        data-cy="course-card"
        @click="gotoPage(card)"
    >
        <div
            class="card-detailed"
        >
            <div class="card-classify">
                <!-- <span
                    v-if="card.season"
                    class="season"
                >{{card.season}}</span>
                <span
                    v-if="card.title_subject"
                    class="subject"
                >{{card.title_subject}}</span> -->
                <nuxt-link
                    class="title"
                    :to="{
                        path: pagePath,
                        query: {
                            course_type: card.courseType,
                            grade: card.grade,
                            signUpPathTag
                        }
                    }"
                    v-html="cardTitle"
                />
            </div>
            <!-- 增加难度等级 -->
            <difficultyLevel :card="card" :show-space="true" />
            <div class="card-teacher">
                <div
                    v-for="(teacher,index) in card.lecturerTeacherList"
                    v-show="index < 3"
                    :key="index"
                    class="teacher"
                >
                    <div class="teacher__icon">
                        <webp-image
                            :key="teacher.avatarUrl"
                            :src="teacher.avatarUrl"
                            width="80"
                            height="80"
                        />
                    </div>
                    <div class="teacher__name ellipsis">{{teacher.name}}</div>
                </div>
            </div>
            <div
                class="card-basic"
            >
                <div class="card-basic__left">
                    <div v-if="isShowsSellTime" class="countdown_time">
                        <span class="stop_sell_time">距停售还剩{{card.endSellCountdown}}天</span>
                    </div>
                    <div class="lesson">
                        <span v-if="card.lectureDesc">{{card.lectureDesc}}</span>
                        <span v-if="card.courseType != 23 && card.subclazzCount">{{card.subclazzCount}}个班级可选</span>
                    </div>
                </div>
                <div class="card-basic__right">
                    <card-price :info="card" :opts="{tagPos: 'left', penny: true}">
                        <div v-if="showSignupButton" class="free-course-btn-wrapper">
                            <button v-if="card.subscribeStatus === 2 || card.subscribeStatus === 4" class="deactive">
                                已报名
                            </button>
                            <button v-else class="active" @click.stop="signUpHandler(card)">
                                免费报名
                            </button>
                        </div>
                    </card-price>
                </div>
            </div>
            <div
                v-if="card.courseTypeDesc"
                class="card-type"
            >
                <span class="card-type__text">{{card.courseTypeDesc}}</span>
            </div>
        </div>
        <div class="stance"></div>
    </div>
</template>
<script>
import webpImage from '@business/components/common/webpImage';
import difficultyLevel from '@business/components/common/DifficultyLevel';
import CardPrice from '@business/components/common/CardPrice';
import {SMALL_CLASS_COURSETYPE} from '@base/constants/course';
import {hasUrgeInfo} from '@base/util/price';
import {SIGN_UP_PATH, COURSE_TYPE_ID_COLLECT} from '@base/constants/signUpPathSource';
import {
    MODULE_NAME,
    EVENT_ID_SEARCH_RESULT_CARD_CLICK,
    EVENT_ID_SEARCH_RESULT_CARD_VIEW,
} from '@base/constants/searchResult';
import {
    EVENT_ID_COURSE_CARD_CLICK
} from '@base/constants/haboEvent';

export default {
    name: 'CourseCard',
    components: {
        difficultyLevel,
        'webp-image': webpImage,
        'card-price': CardPrice
    },
    props: {
        card: {
            type: Object,
            default() {
                return {};
            }
        },
        openSource: {
            type: String,
            default: ''
        },
        systemSource: {
            type: String,
            default: ''
        },
        selectType: {
            type: Number,
            default() {
                return -1;
            }
        },
        index: {
            type: Number,
            default() {
                return 0;
            }
        },
    },
    data() {
        return {
            supportFlag: false,
            signUpPathTag: SIGN_UP_PATH.SIGN_UP_PATH_CATEGORY_COURSE,
        };
    },
    computed: {
        // 是否展示停售时间
        isShowsSellTime() {
            // 如果存在限时限额则不展示停售倒计时
            if (hasUrgeInfo(this.card)) {
                return false;
            }
            if (!this.card.endSellCountdown) {
                return false;
            }
            return Number(this.card.endSellCountdown) !== -1;
        },
        pagePath() {
            const {courseType} = this.card || {};
            const detailPagePath = courseType === 23 ? 'learn' : 'product';
            return this.card.hasSubList
                ? `/sublist/${this.card.courseId}`
                : `/${detailPagePath}/${this.card.clazzId}`;
        },
        cardTitle() {
            return this.card.htmlTitle || this.card.title || '';
        },
        source() {
            const {courseType} = this.card;
            if (COURSE_TYPE_ID_COLLECT.WELFARES_AND_OPEN_COURSE_ARRAY.includes(+courseType)) {
                return this.openSource || SIGN_UP_PATH.SIGN_UP_PATH_CATEGORY_COURSE;
            }
            return this.systemSource || SIGN_UP_PATH.SIGN_UP_PATH_CATEGORY_COURSE;
        },
        // 是否是小班课
        isSmallClass(){
            // 公开课 收费班课 系列课 专题课 体验课
            // 31 32 34 35 36
            return Object.values(SMALL_CLASS_COURSETYPE).includes(this.card.courseType);
        },
        // 是否展示报名按钮
        showSignupButton(){
            return this.card.priceFen === 0 && !this.card.hasSubList && this.card.courseType !== 23 && !this.isSmallClass;
        },
    },
    mounted() {
        const {name} = this.$route;
        const {searchWord = ''} = this.$route.query;
        if (name === 'searchResult') {
            this.$habo.haboViewPage(EVENT_ID_SEARCH_RESULT_CARD_VIEW, {
                clazz_number: this.card.clazzId || this.card.courseId,
                course_type: this.card.courseType,
                search_words: searchWord,
                page_tab: MODULE_NAME[this.selectType],
                source: this.source,
                list_order: this.index + 1,
                search_type: '课程',
                teacher_number: 0
            });
        }
    },
    methods: {
        gotoPage(payload) {
            this.clickReport('课程');
            this.$router.push({
                path: this.pagePath,
                query: {
                    course_type: payload.courseType,
                    grade: payload.grade,
                    signUpPathTag: this.source
                }
            });
        },
        signUpHandler(courseInfo) {
            this.clickReport('公开课卡片按钮');
            this.$emit('on-sign-up', courseInfo);
        },
        clickReport(search_type) {
            const {name} = this.$route;
            const {searchWord = ''} = this.$route.query;
            if (name === 'searchResult') {
                this.$habo.haboClickReport(EVENT_ID_SEARCH_RESULT_CARD_CLICK, {
                    clazz_number: this.card.clazzId || this.card.courseId,
                    course_type: this.card.courseType,
                    search_words: searchWord,
                    page_tab: MODULE_NAME[this.selectType],
                    source: this.source,
                    list_order: this.index + 1,
                    search_type,
                    teacher_number: 0
                });
            }
            else {
                this.$habo.haboClickReport(EVENT_ID_COURSE_CARD_CLICK);
            }
        }
    }
};
</script>
<style lang="less" scoped>
.card-detailed {
    position: relative;
    padding: 30px 20px 0;
    width: 340px;
    background-color: #fff;
    border-radius: 4px;
}

.card-type {
    position: absolute;
    top: -1px;
    right: -1px;
    background-color: #ff777c;
    height: 26px;
    line-height: 26px;
    font-size: 14px;
    color: #fff;
    border-radius: 0 4px 0 21px;
    transition: all .2s linear;

    &::before {
        content: "";
        position: absolute;
        left: -4px;
        top: 0;
        width: 0;
        height: 0;
        line-height: 0;
        font-size: 0;
        overflow: hidden;
        border-radius: 0 33px 67px 35px;
        border-left: 6px dashed transparent;
        border-right: 17px solid #ff777c;
        border-top: 13px solid #ff777c;
        transition: all .2s linear;
    }

    &__text {
        position: relative;
        padding: 0 7px 0 16px;
    }
}

.card-basic {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    position: relative;
    padding: 22px 0;

    &__left {
        position: relative;
        font-size: 12px;
        color: #818a92;

        .countdown_time {
            position: absolute;
            bottom: 15px;

            .stop_sell_time {
                font-size: 12px;
                font-family: PingFangSC, PingFangSC-Regular;
                font-weight: 400;
                text-align: left;
                color: #818a92;
                line-height: 12px;
            }
        }

        .lesson {
            padding-top: 7px;
        }

        span {
            padding-right: 5px;

            i {
                color: #f63232;
                font-style: normal;
            }
        }
    }

    &__right {
        margin-top: 2px;
    }
}

.course-card {
    display: inline-block;
    position: relative;
    width: 380px;
    margin-top: 20px;

    border-radius: 4px;
    transition: all .5s;
    cursor: pointer;

    &:not(:nth-of-type(3n)) {
        margin-right: 30px;
    }
    .stance {
        display: none;
        width: 100%;
        height: 6px;
    }

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 2px;
        right: 2px;
        height: 2px;
        background: none;
        transition: all .2s linear;
        z-index: 1;
    }

    &:hover {
        box-shadow: 0 20px 30px 0 #6f729633;
        transform: translateY(-10px);

        .card-type {
            background-color: #f63232;

            &::before {
                border-right-color: #f63232;
                border-top-color: #f63232;
            }
        }
    }

    &.has_sublist {
        border-radius: 4px 4px 12px 12px;

        .stance {
            display: block;
        }

        .card-detailed {
            &::after,
            &::before {
                content: "";
                position: absolute;
                // left: 189px;
                left: 50%;
                margin-left: -188px;
                // width: 281px;
                width: 374px;
                height: 2px;
                border: solid 1px #ebebeb;
                background-color: #fff;
                border-top: none;
                border-radius: 0 0 4px 4px;
                bottom: -4px;
            }

            &::after {
                // width: 277px;
                width: 370px;
                bottom: -7px;
                margin-left: -186px;
            }
        }
    }
}

.little_padding {
    padding: 20px 0;
}

.offset_y {
    top: 5px;
}

.card-classify {
    position: relative;
    font-size: 0;
    height: 55px;

    span {
        font-size: 14px;

        &.season {
            display: inline-block;
            background-color: #f63232;
            border-radius: 2px;
            padding: 3px;
            border: solid 1px #f63232;
            color: #fff;
            margin-right: 6px;
            vertical-align: middle;
        }

        &.subject {
            display: inline-block;
            border-radius: 2px;
            padding: 3px 4px;
            color: #f63232;
            margin-right: 6px;
            border: solid 1px #f63232;
            vertical-align: middle;
        }

    }

    .title {
        font-size: 20px;
        height: 44px;
        line-height: 28px;
        color: #32404b;
        font-weight: 400;
        margin: 11px 0 18px;
        overflow: hidden;
        vertical-align: middle;
        word-break: break-all;
    }
}

.card-teacher {
    margin-top: 25px;
    position: relative;
    padding-bottom: 20px;
    font-size: 0;
    height: 66px;
    border-bottom: 1px solid #f5f5f5;

    .teacher {
        display: inline-block;
        width: 42px;
        overflow: hidden;

        &:not(:last-child) {
            margin-right: 20px;
        }

        &__icon {
            position: relative;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background-color: #f0f4fa;
            img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
            }
        }

        &__name {
            font-size: 12px;
            text-align: center;
            padding: 7px 0;
            color: #818a92;
        }
    }
}
</style>
